import { bindAppNavigate, unbindAppNavigate } from '@services/appNavigation';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/** Binds React Router `navigate` so non-React code (API interceptor) can redirect. */
const AppNavigationBinder = () => {
  const navigate = useNavigate();

  useEffect(() => {
    bindAppNavigate(navigate);
    return () => unbindAppNavigate();
  }, [navigate]);

  return null;
};

export default AppNavigationBinder;
